<template>
  <div class="Captcha">
    <Verify
      ref="verify"
      @success="success"
      @close="close"
      :captcha-type="captchaType"
      :img-size="{ width: '330px', height: '155px' }"
      :mode="'pop'"
      :show="show"
      :withCredentials="withCredentials"
    />
  </div>
</template>

<script>
import Verify from "./verify/Verify";
export default {
  name: "Captcha",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    captchaType: {
      type: String,
      default: "blockPuzzle",
    },
  },
  components: {
    Verify,
  },
  data() {
    return {
      withCredentials: this.$options.withCredentials,
    };
  },
  methods: {
    // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    success(params) {
      this.$emit("success", params);
      this.$destroy();
    },
    close() {
      this.$emit("close");
      this.$destroy();
    },
  },
};
</script>
